let dirPath = 'static/games/page018_game1';

let configGame = {
  removeInCorrects: false,
  correctBlock: false,
  rulesGame: {
    itemsConfig: { shuffle: true },
    itemsGarbage: [{ idGroup: 'checks', itemsConfig: { block: false } }],
    otherProperty: {
      sounds: [{ src: dirPath + '/audio/klik.mp3', id: 'mouseup' }],
    },
    items: [
      { idGroup: 'checks', idItem: 's00', correct: [{ idGroup: 'checks', idItem: 's00' }] },
      { idGroup: 'checks', idItem: 's01', correct: [{ idGroup: 'checks', idItem: 's01' }] },
      { idGroup: 'checks', idItem: 's02', correct: [{ idGroup: 'checks', idItem: 's02' }] },
      { idGroup: 'checks', idItem: 's03', correct: [{ idGroup: 'checks', idItem: 's03' }] },
      { idGroup: 'checks', idItem: 's04', correct: [{ idGroup: 'checks', idItem: 's04' }] },
    ],
  },
  layout: {
    groups: [
      {
        idGroup: 'checks',
        positions: { pos: { x: 0, y: -50 } },
        itemsConfig: {
          background: {
            text: { size: '40px', textAlign: 'center', textBaseline: 'middle', font: 'Myriad Pro' },
          },
        },
        otherProperty: {
          pair: {
            check: {
              positions: { pos: { width: 350, height: 300 } },
              background: { image: { src: dirPath + '/img/check.png' } },
            },
          },
        },
        items: [
          {
            id: 's00',
            background: {
              image: { src: dirPath + '/img/00.png' },
            },
            positions: { type: 'absolute', pos: { width: 392, height: 236, x: 320, y: 540 } },
            otherProperty: { pair: { check: { positions: { pos: { x: 200 } } } } },
          },
          {
            id: 's01',
            background: {
              image: { src: dirPath + '/img/01.png' },
            },
            positions: { type: 'absolute', pos: { width: 40, height: 50, x: 613, y: 280 } },
            otherProperty: { pair: { check: { positions: { pos: { y: -90 } } } } },
          },
          {
            id: 's02',
            background: {
              image: { src: dirPath + '/img/02.png' },
            },
            positions: { type: 'absolute', pos: { width: 124, height: 110, x: 1023, y: 430 } },
            otherProperty: { pair: { check: { positions: { pos: { y: -60 } } } } },
          },
          {
            id: 's03',
            background: {
              image: { src: dirPath + '/img/03.png' },
            },
            positions: { type: 'absolute', pos: { width: 199, height: 332, x: 1300, y: 270 } },
            otherProperty: { pair: { check: { positions: { pos: { y: -30, x: 60 } } } } },
          },
          {
            id: 's04',
            background: {
              image: { src: dirPath + '/img/04.png' },
            },
            positions: { type: 'absolute', pos: { width: 71, height: 62, x: 1230, y: 114 } },
            otherProperty: { pair: { check: { positions: { pos: { y: -30, x: 60 } } } } },
          },
        ],
      },
    ],
  },
};

let dataConfig = {
  realHeight: 800,
  realWidth: 1800,
  mixinEngine: 'select',
  mainImage: {
    imagePath: dirPath + '/img/bcg.jpg',
    pos: {
      y: 210,
      x: 350,
    },
    width: 1200,
    height: 675,
    cssStyle: {
      positions: 'absolute',
    },
  },
  configGame: configGame,
};

export default dataConfig;
